
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesItemsWithoutTaxSelectGrid extends _Ext.GridBase<POSSalesItemsRow, any> {
        
        protected getColumnsKey() { return 'Retail.POSSalesItemsSelect'; }
        protected getDialogType() { return <any>POSSalesItemsDialog; }
        protected getIdProperty() { return POSSalesItemsRow.idProperty; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected getService() { return POSSalesWithoutTaxItemsService.baseUrl}
          

        constructor(container: JQuery, options: any) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });
            this.element.height(650);
            this.addQuickFilter({
                type: Retail.TempEditor,
                title: "",
                separator: false,
                field: "ItemTypeId"
            });

            var hasbom = options.GridFilters.HasBom;
            if (hasbom != undefined && hasbom)
                (this.view.params as TransactionRequest).HasBom = hasbom;


            var studded = options.GridFilters.Studded;
            if (studded != undefined && studded != null)
                (this.view.params as TransactionRequest).Studded = studded;

            var metalcolorid = options.GridFilters.MetalColorId;
            if (metalcolorid != undefined && metalcolorid)
                (this.view.params as TransactionRequest).MetalColorId = metalcolorid;


            var karatid = options.GridFilters.KaratId;
            if (karatid != undefined && karatid != null)
                (this.view.params as TransactionRequest).KaratId = karatid;

            var deptid = options.GridFilters.DepartmentId;
            if (deptid != undefined && deptid != null)
                (this.view.params as TransactionRequest).DepartmentId = deptid;

            var filteritem = options.GridFilters.FilterItems;
            let propertyName: string = "s-TempEditor s-Retail-TempEditor";
            let radioElement: JQuery = $("[class$='" + propertyName + "']").find("label");

            let radioElement2: JQuery = $("[class$='" + propertyName + "']");
            //J-Jewellery       M-Metal      S-Stone
            if (filteritem == 1 || filteritem == undefined) {//For JMS
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;");

            }
            else if (filteritem == 2) {//For JM
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 3) {//For JS
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[2];
                let item3 = radioElement[1];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 4) {//For MS
                let item1 = radioElement[1];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[2];
                let item3 = radioElement[0];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 5) {//For J
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 6) {//For M
                let item1 = radioElement[1];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[0];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 7) {//For S
                let item1 = radioElement[2];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[0];
                let item3 = radioElement[1];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            return this;
        }
        private autoSize; 

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): POSSalesItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}